module.exports = __webpack_public_path__ + "img/battery_5green.b762f294.png";